




































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import FamiliesMixin from "../../mixins/http/FamiliesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import CompanyFamilyItem from "@/components/CompanyFamily/Item.vue";
import CompanyFamiliesMixin from "@/mixins/http/CompanyFamiliesMixin";
import { CompanyFamily } from "../../models";

@Component({ components: { Page, CompanyFamilyItem } })
export default class CompanyFamilyList extends Mixins(CompanyFamiliesMixin) {
  static readonly getFamiliesTag = "get_company_companyFamilies_tag";
  @RegisterHttp(CompanyFamilyList.getFamiliesTag)
  getFamiliesRequest: RequestData;
  private companyFamilies: CompanyFamily[] = [];

  mounted() {
    this.loadCompanyFamilies();
  }

  get loading() {
    return this.getFamiliesRequest?.loading;
  }

  goToCompanyFamily(id) {
    this.$router.push({ name: "company_family", params: { id: id } });
  }

  async loadCompanyFamilies() {
    this.companyFamilies = await this.getCompanyFamilies(
      {},
      CompanyFamilyList.getFamiliesTag
    );
  }
}
